const types = state => state.types

export default {
  types
}
